import React, { Component } from "react";
import moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DataGridModel from './DataGridModel';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';

// import 'react-day-picker/lib/style.css';
/**
 * This is a base grid component for display data in a grid.
 * 
 * Just pass in data and follow model (to come) to change aspects of it
 * 
 */
class GridSource extends Component {
    constructor(props) {
        super(props);
        this.bHasWindow = typeof window !== "undefined";
        // this._isMounted = false;
        this.state = {
            showLoader: props.showLoader ? props.showLoader : false,
            dataLoaded: false,
            unfilteredDataSource: props.dataSource,
            dataView: [],
            dataRows: null,
            sortColumn: "",
            sortDirection: "asc",
            headerColumns: [],
            selectedRows: [],
            filterData: {},
            searchText: "",
            dateRange: { from: "", to: "" },
            currentFilterListElement: null,
            currentFilterApplied: { filter: null, selection: null },
            allRowsSelected: false,
            dateInputs: { from: React.createRef(), to: React.createRef() },
            gridOptions: new DataGridModel()
        };
        if (!this.state.unfilteredDataSource) {
            this.state.unfilteredDataSource = [];
        }
        if (props.gridOptions) {
            let newGridOptions = this.state.gridOptions;
            Object.keys(props.gridOptions).map((option) => {
                newGridOptions[option] = props.gridOptions[option];
            });
            this.state.gridOptions = newGridOptions;
            if (this.state.gridOptions.initialDate) this.state.dateRange = this.state.gridOptions.initialDate;
        }
        this.generateHeaderRow = this.generateHeaderRow.bind(this);
        this.generateDataRows = this.generateDataRows.bind(this);
        this.initializeData = this.initializeData.bind(this);
        this.exportXLS = this.exportXLS.bind(this);
        this.exportPDF = this.exportPDF.bind(this);
        this.SelectRow = this.SelectRow.bind(this);
        this.SortBy = this.SortBy.bind(this);
        this.sort_by = this.sort_by.bind(this);
        this.ToggleFilterMenu = this.ToggleFilterMenu.bind(this);
        this.rowClickFunction = this.rowClickFunction.bind(this);
        this.filterCallback = this.filterCallback.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.searchData = this.searchData.bind(this);
        this.filterData = this.filterData.bind(this);
        this.filterByDate = this.filterByDate.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.showLoader !== prevProps.showLoader) {
            this.setState({ showLoader: this.props.showLoader });
        }

        if (this.props.dataSource !== prevProps.dataSource) {
            this.initializeData(this.props.dataSource, true);
        }
    }

    componentDidMount() {
        if (!this.props.showLoader) this.initializeData(this.props.dataSource, true);
    }

    initializeData(dataSource, setUnfilteredDataSource) {
        let useThisData = dataSource ? dataSource : this.props.dataSource;
        if (!useThisData || useThisData.length === 0) useThisData = [];
        let filters = {}; //only used for generating filter options, not for filtering rows
        let processedData = useThisData.map((item, i) => {
            !item.gridId ? item.gridId = i : "";
            //instantiate filters
            this.state.gridOptions.filters.map(filter => {
                if (!filters[filter.dataKeyToUse]) filters[filter.dataKeyToUse] = []; //if array not intialized for filter, initialize filter []
                if (item[filter.dataKeyToUse] && !filters[filter.dataKeyToUse].find((option) => { return option === item[filter.dataKeyToUse] })) { //if item is not in filter array... if item is not null
                    filters[filter.dataKeyToUse].push(item[filter.dataKeyToUse]) //push value to array else ignore
                }
            })
            return item;
        });
        // if (setUnfilteredDataSource) {
        //     this.setState({unfilteredDataSource: processedData});
        // }
        //You want to set the sort direction to the opposite of what you want because when the sort function is ran it will flip the direction
        this.setState({
            dataView: processedData,
            sortColumn: this.state.gridOptions.columns[0].value,
            sortDirection: this.state.gridOptions.columns[0].type === "string" ? "desc" : "asc",
            filterData: filters,
            unfilteredDataSource: setUnfilteredDataSource ? processedData : this.state.unfilteredDataSource,
        }, () => {
            // this.generateDataRows();
            if (this.state.dataView.length > 0) this.SortBy(this.state.gridOptions.columns[0].value, this.state.gridOptions.columns[0].type);
            // this.forceUpdate();
        });
    }

    rowClickFunction(rowData) {
        if (typeof (this.props.gridOptions.rowClick) === "function") this.props.gridOptions.rowClick(rowData);
    }

    filterCallback(type) {
        let data = {
            searchText: this.state.searchText,
            dateRange: this.state.dateRange,
            currentFilterApplied: this.state.currentFilterApplied
        }
        if (typeof (this.props.gridOptions.filterCallback) === "function") this.props.gridOptions.filterCallback(type, data);
    }

    async exportXLS() {
        if (this.state.showLoader) return;
        try {
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let useThisData = this.state.selectedRows.length > 0 ? this.state.selectedRows : this.state.dataView;

            //Data has to be initialized like this, do not use 'delete' on object property or it will break state
            let gridData = useThisData.map((row) => {
                let newRow = {};
                Object.keys(row).map((key) => {
                    let column = this.state.headerColumns.find((header) => {
                        return header.value === key;
                    })
                    if (!column || (column && column.excludeFromExport)) return;
                    newRow[key] = this.DisplayData(row[key], column.type);
                });
                return newRow;
            });

            let columns = [];
            this.state.gridOptions.columns.forEach((column) => {
                if (!column.excludeFromExport) {
                    columns.push({ title: column.title, dataKey: column.value });
                }
            });
            var ws = XLSX.utils.json_to_sheet(gridData, { header: columns.map((col) => { return col.dataKey }) });
            // var range = XLSX.utils.decode_range(ws['!ref']);
            for (var C = 0; C <= columns.length; ++C) {
                var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                if (!ws[address]) continue;
                ws[address].v = columns[C].title;
            }
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, this.state.gridOptions.exportName + fileExtension);

        } catch (ex) {
            console.log(ex);
        }
    }

    async exportPDF() {
        if (this.state.showLoader) return;
        try {
            const doc = new jsPDF();
            let gridData = this.state.selectedRows.length > 0 ? this.state.selectedRows : this.state.dataView;
            gridData = gridData.map((row) => {
                let newRow = {};
                Object.keys(row).map((key) => {
                    let column = this.state.headerColumns.find((header) => {
                        return header.value === key;
                    })
                    if (!column || (column && column.excludeFromExport)) return;
                    newRow[key] = this.DisplayData(row[key], column.type);
                });

                return newRow;
            });
            let columns = [];
            this.state.gridOptions.columns.forEach((column) => {
                if (!column.excludeFromExport) {
                    columns.push({ header: column.title, dataKey: column.value });
                }
            });
            doc.autoTable({
                body: gridData,
                columns: columns
            })
            doc.save(`${this.state.gridOptions.exportName}.pdf`);

        } catch (ex) {
            console.log(ex);
        }
    }

    generateHeaderRow() {
        if (this.state.dataView && this.state.dataView.length > 0) {
            if (this.state.gridOptions && this.state.gridOptions.columns) {
                // this.setState({headerColumns: this.state.gridOptions.columns});
                this.state.headerColumns = this.state.gridOptions.columns;
            } else {
                let headerView = [];
                Object.keys(this.state.dataView[0]).map((column) => {
                    if (column === "gridId") return;
                    let newColumn = {
                        title: column,
                        value: column,
                        allowSorting: true
                    }
                    headerView.push(newColumn);
                });
                // this.setState({headerColumns: headerView});
                this.state.headerColumns = headerView;
            }
            return (
                <div className={`row dataGrid-row ${/*this.state.gridOptions.selectable ? "dataGrid-header": "dataGrid-header-no-select"*/""}`}>
                    {this.state.gridOptions && this.state.gridOptions.selectable ?
                        <label onClick={e => e.stopPropagation()} className="dataGrid-checkbox-container">
                            <input type="checkbox" checked={this.state.allRowsSelected} onChange={() => { this.SelectRow(null, true) }} />
                            <span className="dataGrid-checkmark" />
                        </label>
                        : ""}
                    {this.state.headerColumns.map((col, key) => {
                        if (col.title === "gridId") return;
                        return (
                            <div key={`header${key}`} className={`col bold-text ${col.columnSizeClass || ""} dataGrid-column ${!col.allowSorting || "dataGrid-clickable"} ${key === 0 ? "dataGrid-adjust-edit-header" : ""} ${col.hideOnTablet ? "dataGrid-tablet-hide" : ""}`} onClick={() => { if (col.allowSorting) this.SortBy(col.value, col.type) }}>
                                {col.title}
                                {col.allowSorting ?
                                    <span className={`dataGrid-sort-arrow ${(this.state.sortColumn != col.value) ? "icon-arrow-sm-down" : ((col.type === 'date' && this.state.sortDirection === 'asc') || (col.type !== 'date' && this.state.sortDirection === "desc")) ? "icon-arrow-sm-up" : "icon-arrow-sm-down"}`} />
                                    :
                                    ""
                                }
                            </div>
                        );
                    })}
                </div>
            );
        }
    }

    generateDataRows() {
        if (this.state.dataView && this.state.dataView.length > 0) {
            let dataRows = (this.state.dataView.map((rowData) => {
                return (
                    <div key={`rowKey${rowData.gridId}`} className={`row dataGrid-row ${this.state.selectedRows.find(r => { return r.gridId === rowData.gridId }) ? "dataGrid-row-selected" : ""} ${typeof (this.props.gridOptions.rowClick) === "function" ? "dataGrid-clickable" : ""}`} onClick={() => { this.rowClickFunction(rowData) }}>
                        {this.state.gridOptions && this.state.gridOptions.selectable ?
                            <label onClick={e => e.stopPropagation()} className="dataGrid-checkbox-container">
                                <input type="checkbox" checked={this.state.selectedRows.find(r => { return r.gridId === rowData.gridId }) ? true : false}
                                    onChange={() => { this.SelectRow(rowData) }}
                                />
                                <span className="dataGrid-checkmark" />
                            </label>
                            : ""}
                        {this.state.headerColumns.map((colData, colKey) => {
                            return (
                                <div key={`colKey${colKey}`} className={`${colData.columnSizeClass || "col-sm"} dataGrid-column ${colData.hideOnTablet ? "dataGrid-tablet-hide" : ""} ${colData.alignTextRight ? "dataGrid-text-right" : ""}`}>
                                    <span className="dataGrid-mobile-view dataGrid-header-mobile-label">{colData.title}:</span>
                                    {
                                        colData.type === "progress" ? 
                                            <div className="dataGrid-column-data dataGrid-subtext-column">
                                                <div className="card-body gauge-container">
                                                    <div className="row">
                                                        <div className="col-12 gauge-wrapper">
                                                            <div className="gauge-container">
                                                                <div className="gauge-background-bar">
                                                                    <div className="gauge-filled-bar" style={{ width: `${(rowData[colData.value])}%` }}></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="dataGrid-subtext">{rowData[colData.subtextValue]}%</div>
                                            </div>
                                        :
                                        <div
                                            className={`dataGrid-column-data ${colData.subtextValue && rowData[colData.subtextValue] ? "dataGrid-subtext-column" : ""} ${typeof (colData.clickCallback) === "function" ? "dataGrid-link" : ""} ${colData.customCSSMapToValue && colData.customCSSMapToValue.trim().length > 0 ? rowData[colData.customCSSMapToValue] : ""}`}
                                            onClick={(e) => { if (colData.clickCallback) { e.stopPropagation(); colData.clickCallback(rowData) } }}
                                        >
                                                {this.DisplayData(colData.staticContent || rowData[colData.value], colData.type, colData.showEmptyIfNull, colData.dateFormat, rowData[colData.isCurrency])}
                                            {colData.subtextValue && rowData[colData.subtextValue] ? <div className="dataGrid-subtext">{this.DisplayData(rowData[colData.subtextValue], colData.subtextType)}</div> : ""}
                                        </div>
                                        }
                                </div>
                            )
                        })}
                        <div className="icon-arrow-sm-rt dataGrid-mobile-view dataGrid-mobile-click-arrow">
                        </div>
                    </div>
                );
            }));
            this.setState({ dataRows: dataRows });
            return dataRows;
        }
    }

    DisplayData(data, type, showEmpty, dateFormat, isCurrency) {
        var dataType = typeof (data);
        if (type) {
            dataType = type;
        }
        if (dataType === "string") {
            //if same column has currency and unit values
            if (isCurrency) {
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
                return formatter.format(data);
            }
            return data;
        } else if (dataType === "currency") {//if entire column contain currency
            if (data === null && showEmpty) return "";
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });
            return formatter.format(data);
        } else if (data instanceof Date || dataType === "date") {
            if (data) {
                return moment(data).format(dateFormat || "MM/DD/YYYY");
            }
            else
                return;
        }
        return data;
    }

    SortBy(columnName, columnType, applySortOnly) {
        var sortDirection = this.state.sortDirection;
        var sortColumn = this.state.sortColumn;
        if (!applySortOnly) {
            if (columnName == sortColumn) {
                if (sortDirection == "desc") {
                    sortDirection = "asc";
                }
                // else if (sortDirection == "asc") {
                //     sortColumn = "";
                //     sortDirection = "";
                // }
                else {
                    sortDirection = "desc";
                }
            }
            else {
                sortDirection = "desc";
                sortColumn = columnName;
            }
        }
        var primer = "";
        if (columnType == "number") {
            primer = parseInt;
        }
        else if (columnType == "date") {
            primer = this.parseDate;
        }
        else if (columnType == "string") {
            primer = (a) => a.toLowerCase();
        }
        else {
            primer = function (x, y) {
                return (x === y) ? 0 : x ? -1 : 1;
            };
        }

        var sortData = this.state.dataView;
        if (sortDirection !== "") {
            sortData = [].concat(this.state.dataView)
                .sort(this.sort_by(columnName, (sortDirection === "asc") ? true : false, !columnType ? function (a) { return a } : primer));
        }

        this.setState({
            dataView: sortData, sortDirection: sortDirection, sortColumn: sortColumn
        }, () => {
            this.generateDataRows();
        });

    }

    sort_by(field, reverse, primer) {
        var key = function (x) { return primer ? primer(x[field]) : x[field] };
        return function (a, b) {
            var A = key(a), B = key(b);
            return ((A < B) ? -1 : ((A > B) ? 1 : 0)) * [-1, 1][+!!reverse];
        };
    }

    SelectRow(rowData, selectAll) {
        if (selectAll) {
            if (this.state.allRowsSelected) {
                this.setState({ allRowsSelected: false, selectedRows: [] }, () => this.generateDataRows());
            } else {
                this.setState({ allRowsSelected: true, selectedRows: this.state.dataView }, () => this.generateDataRows());
            }

            return;
        }

        //Check if row selected
        let selectedRows = this.state.selectedRows.filter((row) => {
            if (row.gridId === rowData.gridId) {
                return false;
            }
            return true;
        })
        if (selectedRows.length === this.state.selectedRows.length) {
            selectedRows.push(rowData);
        }
        this.setState({ selectedRows: selectedRows, allRowsSelected: false }, () => this.generateDataRows());
    }

    ToggleFilterMenu(e) {
        if (!e && this.state.currentFilterListElement) {
            this.state.currentFilterListElement.classList.toggle("dataGrid-show-filters");
            this.setState({ currentFilterListElement: null });
            document.removeEventListener("mousedown", this.ToggleFilterMenu);
            return;
        }

        if (this.state.currentFilterListElement) { //checks if list is open
            if (this.state.currentFilterListElement.contains(e.target)) return; //if click contains element, return because it was clicked within           
            this.state.currentFilterListElement.classList.toggle("dataGrid-show-filters"); //else hide list                   
            this.setState({ currentFilterListElement: null }); //set to null
            // if (this.state.currentFilterApplied.filter) this.filterData();
            document.removeEventListener("mousedown", this.ToggleFilterMenu);
            return;
        }

        let listElement = e.target.nextElementSibling;
        listElement.classList.toggle("dataGrid-show-filters");

        if (this.state.currentFilterListElement === listElement) {
            this.setState({ currentFilterListElement: null });
            return;
        } else if (this.state.currentFilterListElement) {
            this.state.currentFilterListElement.classList.toggle("dataGrid-show-filters");
        }
        document.addEventListener("mousedown", this.ToggleFilterMenu);

        this.setState({ currentFilterListElement: listElement });
    }

    applyFilter(data, clear) {
        if (clear) {
            // this.setState({currentFilterApplied: {filter: null, selection: null}, dataView: this.state.unfilteredDataSource}, () => this.generateDataRows()); 
            this.setState({ currentFilterApplied: { filter: null, selection: null } });
            return data;
        }
        if (!this.state.currentFilterApplied.filter) return;
        let filteredData = data.filter((item) => {
            return item[this.state.currentFilterApplied.filter.dataKeyToUse] === this.state.currentFilterApplied.selection;
        });
        // this.setState({dataView: filteredData}, () => {this.generateDataRows(); this.ToggleFilterMenu()});
        if (this.state.currentFilterListElement) this.ToggleFilterMenu();
        return filteredData;
    }

    searchData(data) {
        if (this.state.searchText === "") {
            // this.setState({dataView: this.state.unfilteredDataSource}, () => {this.generateDataRows();});
            return data;
        }
        let searchText = this.state.searchText.toLowerCase();
        let searchFields = this.state.gridOptions.searchFields.length > 0 ? this.state.gridOptions.searchFields : Object.keys(this.state.dataView);

        let searchResult = searchFields.map((field) => {
            return data.filter((row) => {
                if (!row[field])
                    return;

                return row[field].toString().toLowerCase().includes(searchText);
            });
        });

        let jointArray = [];

        searchResult.forEach(array => {
            jointArray = [...jointArray, ...array]
        });
        const result = jointArray.filter((item, index) => jointArray.indexOf(item) === index);

        return result;
        // this.setState({dataView: result}, () => {this.generateDataRows();});
    }

    filterByDate(data) {
        let dateFilteredData = data.filter((item) => {
            return moment(item[this.state.gridOptions.dateField]).isBetween(moment(this.state.dateRange.from), moment(this.state.dateRange.to));
        });
        return dateFilteredData;
    }

    filterData(options) { //MAIN THING TO CALL WHICH FILTERS EVERYTHING
        // let preResult = this.state.unfilteredDataSource;
        let result = this.state.unfilteredDataSource;

        if (this.state.currentFilterApplied.filter) {
            result = this.applyFilter(result, options ? options.clearDropdownFilter : false);
        }

        if (this.state.searchText.length > 0) {
            result = this.searchData(result);
        }

        if (this.state.dateRange.from && this.state.dateRange.to && moment(this.state.dateRange.from).isValid() && moment(this.state.dateRange.to).isValid() && this.state.searchText.length === 0) {
            result = this.filterByDate(result);
        }
        this.setState({ dataView: result, selectedRows: [], allRowsSelected: false }, () => {
            if (this.state.dataView.length > 0) {
                let sortType = this.state.headerColumns.find((headerColumn) => { return headerColumn.value === this.state.sortColumn });
                this.SortBy(this.state.sortColumn, sortType.type || null, true)
            } else {
                this.generateDataRows();
            }
        });
    }

    render() {
        return (
            <div id={this.props.id || `dataGrid-${this.state.gridOptions.title}`} className="dataGrid-wrapper">
                <div className={`dataGrid-top ${(!this.state.gridOptions.title || this.state.gridOptions.title === "") && !this.state.gridOptions.enableSearch && !this.state.gridOptions.enableDateRange && !this.state.gridOptions.enableFilters && !this.state.gridOptions.enableExport ? "dataGrid-hide" : ""}`}>                   
                    <div className={`${(this.state.gridOptions.isSubGrid) ? "dataGrid-subGridTitle" : "dataGrid-title"}`}>
                        {this.state.gridOptions.title}
                    </div>
                    <div className="dataGrid-subTitle">
                        {this.state.gridOptions.subTitle}
                    </div>
                    <div className="dataGrid-controls">
                        {(this.state.gridOptions.enableSearch || this.state.gridOptions.enableDateRange)
                            ?
                            <div className="row dataGrid-top-filter-row">
                                {this.state.gridOptions.enableSearch
                                    ?
                                    <div className={` ${!this.state.gridOptions.enableDateRange ? "col-12 col-lg-12" : "col-12 col-lg-5"} dataGrid-search-box-container `}>
                                        <input type="text" disabled={this.state.showLoader} value={this.state.searchText} placeholder={this.state.gridOptions.searchPlaceholder} onChange={(e) => this.setState({ searchText: e.target.value })} onKeyUp={() => { this.filterCallback("search"); if (this.state.gridOptions.stopSearchFilterPropogation) return; this.filterData() }} className="dataGrid-search-box"></input>
                                        <div className="icon-search dataGrid-search-icon"></div>
                                    </div>
                                    :
                                    ""
                                }
                                {this.state.gridOptions.enableDateRange
                                    ?
                                    <div className={`col-12 col-lg-7 dataGrid-tablet-push-up ${!this.state.gridOptions.enableSearch ? "dataGrid-push-right" : ""} dataGrid-date-range-wrapper`}>
                                        <div className="dataGrid-date-range-container">
                                            <div className="dataGrid-date-range-label">From</div>
                                            <DayPickerInput ref={this.state.dateInputs.from}
                                                formatDate={formatDate}
                                                parseDate={parseDate}
                                                value={this.state.dateRange.from}
                                                inputProps={{ onKeyUp: (e) => { if (e.key === "Enter") this.state.dateInputs.from.current.hideDayPicker(); }, className: `dataGrid-date-range-input ${!this.state.showLoader || 'dataGrid-hide-cursor-pointer'}`, readOnly: this.state.showLoader, disabled: this.state.showLoader }}
                                                placeholder="MM/DD/YYYY"
                                                onDayChange={(value) => this.setState({ dateRange: { from: value, to: this.state.dateRange.to } })}
                                                onDayPickerHide={() => { this.state.dateInputs.from.current.hideDayPicker(); this.state.dateInputs.to.current.hideDayPicker(); this.filterCallback("date"); if (this.state.gridOptions.stopDateFilterPropogation) return; this.filterData() }}>
                                            </DayPickerInput>
                                            <div className="icon-calendar-form dataGrid-calendar-icon"></div>
                                        </div>
                                        <div className="dataGrid-date-range-container">
                                            <div className="dataGrid-date-range-label">To</div>
                                            <DayPickerInput ref={this.state.dateInputs.to}
                                                formatDate={formatDate} parseDate={parseDate}
                                                value={this.state.dateRange.to}
                                                classNames={{ container: "DayPickerInput", overlayWrapper: "DayPickerInput-OverlayWrapper", overlay: "DayPickerInput-Overlay dataGrid-calendar-right" }}
                                                inputProps={{ onKeyUp: (e) => { if (e.key === "Enter") this.state.dateInputs.to.current.hideDayPicker(); }, className: `dataGrid-date-range-input ${!this.state.showLoader || 'dataGrid-hide-cursor-pointer'}`, readOnly: this.state.showLoader, disabled: this.state.showLoader }}
                                                placeholder="MM/DD/YYYY"
                                                onDayChange={(value) => this.setState({ dateRange: { from: this.state.dateRange.from, to: value } })}
                                                onDayPickerHide={() => { this.state.dateInputs.from.current.hideDayPicker(); this.state.dateInputs.to.current.hideDayPicker(); this.filterCallback("date"); if (this.state.gridOptions.stopDateFilterPropogation) return; this.filterData() }}>
                                            </DayPickerInput>
                                            <div className="icon-calendar-form dataGrid-calendar-icon"></div>
                                        </div>
                                    </div>
                                    :
                                    ""
                                }
                            </div>
                            :
                            ""
                        }
                        {(this.state.gridOptions.enableFilters || this.state.gridOptions.enableExport) ?
                            <div className="row dataGrid-bottom-filter-row">
                                {this.state.gridOptions.enableFilters && this.state.filters !== {} && Object.keys(this.state.filterData).filter((item) => { return this.state.filterData[item].length > 0 }).length > 0 && !this.state.showLoader ?
                                    <div className="col-12 col-lg-8 dataGrid-filters">
                                        <div className="dataGrid-filter-label">
                                            Filter by:
                                        </div>
                                        <div className="dataGrid-filter-buttons dataGrid-mobile-push-up">
                                            {this.state.gridOptions.filters.map((filter, key) => {
                                                if (this.state.filterData[filter.dataKeyToUse] && this.state.filterData[filter.dataKeyToUse].length <= 0) return;
                                                return (
                                                    <div key={`filter-button-${key}`} className="dataGrid-filter-button-item" style={{ width: `${100 / this.state.gridOptions.filters.length}%` }}>
                                                        <input type="button" className={`btn dataGrid-button ${this.state.currentFilterApplied.filter && this.state.currentFilterApplied.filter.filterName == filter.filterName ? 'dataGrid-filter-applied' : ''}`} value={filter.filterName} onClick={(e) => this.ToggleFilterMenu(e)}></input>
                                                        <div className="dataGrid-filter-list-container">
                                                            <div className="dataGrid-filter-list">
                                                                {this.state.filterData[filter.dataKeyToUse] ? this.state.filterData[filter.dataKeyToUse].map((listItem, itemKey) => {
                                                                    return (
                                                                        <div key={`${filter.filterName}-filter-list-item-${itemKey}`} className="dataGrid-filter-list-item">
                                                                            <label className="radio-btn-container">
                                                                                <input type="radio" name={listItem} checked={filter === this.state.currentFilterApplied.filter && listItem === this.state.currentFilterApplied.selection}
                                                                                    onChange={e => this.setState({ currentFilterApplied: { filter: filter, selection: listItem } })}
                                                                                />
                                                                                <span className="radio-btn" />
                                                                                <span className="filter-name dataGrid-filter-name">{listItem}</span>
                                                                            </label>
                                                                        </div>
                                                                    )
                                                                }) : ""}
                                                            </div>
                                                            <div className="dataGrid-filter-list-control-container">
                                                                <div className="dataGrid-filter-list-controls">
                                                                    <span className="dataGrid-filter-control-clear" onClick={() => { this.filterCallback("filter-clear"); if (this.state.gridOptions.stopFilterButtonPropogation) return; this.filterData({ clearDropdownFilter: true }) }}>Clear</span>
                                                                    <span className="dataGrid-filter-control-apply" onClick={() => { this.filterCallback("filter"); if (this.state.gridOptions.stopFilterButtonPropogation) return; this.filterData() }}>Apply</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    :
                                    ""}
                                {this.state.gridOptions.enableExport ?
                                    <div className={`col-4 ${this.state.filterData === {} || Object.keys(this.state.filterData).filter((item) => { return this.state.filterData[item].length > 0 }).length <= 0 ? "dataGrid-push-right" : ""} dataGrid-exports`}>
                                        <div className="dataGrid-filter-label">
                                            Export as:
                                        </div>
                                        <div className="dataGrid-export-buttons">
                                            {this.props.gridOptions.exportFormats.find((e) => { return e === "xls" }) ? <div className="icon-excell dataGrid-export-icon dataGrid-export-excel" onClick={() => this.exportXLS()}></div> : ""}
                                            {this.props.gridOptions.exportFormats.find((e) => { return e === "pdf" }) ? <div className="icon-pdf dataGrid-export-icon dataGrid-export-pdf" onClick={() => this.exportPDF()}></div> : ""}
                                        </div>
                                    </div>
                                    :
                                    ""}
                            </div>
                            :
                            ""}
                    </div>
                </div>
                {this.state.showLoader
                    ?
                    <div className="dataGrid-loading-container">
                        <div className="dataGrid-loading-icon">
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                        </div>
                    </div>
                    :
                    this.state.dataView && this.state.dataView.length > 0
                        ?
                        <div className="dataGrid-container">
                            {this.generateHeaderRow()}
                            {this.state.dataRows}
                        </div>
                        :
                        <div className="dataGrid-no-data-message">
                            {this.state.gridOptions.noDataMessage}
                        </div>
                }
            </div>
        );
    }

    //copied from DataComponent.js
    //componentDidMount() {
    //    if (super.componentDidMount) { super.componentDidMount(); }

    //    this._isMounted = true;
    //    this.privateLoadData();
    //}

    //componentDidUpdate(prevProps, prevState, snapshot) {
    //    if (super.componentDidUpdate) { super.componentDidUpdate(prevProps, prevState, snapshot); }

    //    this.privateLoadData();
    //}

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.ToggleFilterMenu);
    }

    //privateLoadData() {
    //    const { dataLoaded } = this.state;
    //    if (!dataLoaded && this.shouldLoadData && this.shouldLoadData()) {
    //        this.setState({ dataLoaded: true });
    //        if (this.loadData) {
    //            this.loadData();
    //        }
    //    }
    //}


}


export default GridSource;